import React from 'react';

export default function Sidebar({ user, onLogout, onQuerySelect, isOpen, onClose }) {
  const suggestedQueries = {
    campaigns: {
      title: "🎯 Výkon kampaní",
      queries: [
        "Jak fungují bannery tento týden?",
        "Porovnej DA_rtb vs Google Ads za posledních 14 dní",
        "Které kampaně mají nejlepší conversion rate?",
        "Kolik konverzí přinesly bannery tento měsíc?",
        "Jak si vedou placené zdroje dnes?"
      ]
    },
    conversions: {
      title: "📊 Konverze a události",
      queries: [
        "Kolik bylo purchase událostí dnes?",
        "Add to cart rate za posledních 14 dní",
        "Jaký je conversion funnel za tento týden?",
        "Které zdroje mají nejvyšší conversion rate?",
        "Kolik transakcí bylo včera?"
      ]
    },
    behavior: {
      title: "👥 Chování uživatelů",
      queries: [
        "Průměrný čas na stránce per zdroj",
        "Bounce rate srovnání desktop vs mobile",
        "Top landing pages pro bannery",
        "Jaké stránky mají nejdelší engagement?",
        "Kde uživatelé nejvíc opouštějí stránku?"
      ]
    },
    sources: {
      title: "🔍 Zdroje návštěvnosti",
      queries: [
        "Odkud přišli uživatelé tento týden?",
        "Porovnej organickou návštěvnost s placenou",
        "Které zdroje přinesly nejvíce návštěv?",
        "Jak funguje organika vs PPC?",
        "Top 5 zdrojů za posledních 7 dní"
      ]
    }
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          w-64 flex-shrink-0 bg-surface-light dark:bg-surface-dark
          border-r border-border-light dark:border-border-dark
          p-6 flex flex-col
          fixed lg:static inset-y-0 left-0 z-50
          transform transition-transform duration-200
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <img
              src="http://digitalad.cz/wp-content/uploads/2017/07/digitalad_logo-768x138.png"
              alt="DigitalAd"
              className="h-8 w-auto"
            />
          </div>
          <button
            className="lg:hidden p-1 hover:bg-background-light dark:hover:bg-background-dark rounded"
            onClick={onClose}
          >
            <span className="material-symbols-outlined text-lg">close</span>
          </button>
        </div>

        {/* Suggested Queries */}
        <div className="flex-1 overflow-y-auto">
          <h3 className="font-semibold text-text-light dark:text-text-dark mb-4 text-sm">
            Zkuste se zeptat:
          </h3>
          <div className="flex flex-col gap-4">
            {Object.entries(suggestedQueries).map(([categoryKey, category]) => (
              <div key={categoryKey}>
                <h4 className="text-xs font-semibold text-primary mb-2">
                  {category.title}
                </h4>
                <div className="flex flex-col gap-1.5">
                  {category.queries.map((query, idx) => (
                    <button
                      key={idx}
                      className="w-full text-left px-3 py-2 text-xs bg-background-light dark:bg-background-dark border border-border-light dark:border-border-dark rounded-lg hover:bg-primary hover:text-white hover:border-primary transition-colors"
                      onClick={() => {
                        onQuerySelect(query);
                        onClose();
                      }}
                    >
                      {query}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* User Info */}
        <div className="flex-shrink-0 pt-4 border-t border-border-light dark:border-border-dark mt-4">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-full bg-muted-light/20 dark:bg-muted-dark/20 flex items-center justify-center">
              <span className="material-symbols-outlined text-base text-muted-light dark:text-muted-dark">
                person
              </span>
            </div>
            <span className="text-sm text-muted-light dark:text-muted-dark truncate flex-1">
              {user?.email}
            </span>
          </div>
          <button
            onClick={onLogout}
            className="w-full px-4 py-2 text-sm bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border border-red-200 dark:border-red-800 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors flex items-center justify-center gap-2"
          >
            <span className="material-symbols-outlined text-base">logout</span>
            Odhlásit se
          </button>
        </div>
      </aside>
    </>
  );
}
